<script setup>
import ApiChangeLogRow from "@/components/admin/apiChangeLog/partials/ApiChangeLogRow.vue";
import ZeroContent from "@/components/global-themed/ZeroContent.vue";
import TableBody from "@/components/global-themed/table/TableBody.vue";
import DataTable from "@/components/global-themed/table/DataTable.vue";
import TableHeaderRow from "@/components/global-themed/table/TableHeaderRow.vue";
import TableHeaderCell from "@/components/global-themed/table/TableHeaderCell.vue";
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import EditApiChangeLogModal from "@/components/admin/apiChangeLog/modals/EditApiChangeLogModal.vue";
import DeleteApiChangeModal from "@/components/admin/apiChangeLog/modals/DeleteApiChangeModal.vue";

import {useApiChangeLogs} from "@/composables/admin/useApiChangeLogs";

const {data, isLoading} = useApiChangeLogs()
</script>

<template>
  <LoadingBlock v-if="isLoading" />

  <DataTable v-else>
    <TableHeaderRow class="!tw-grid-cols-11">
      <TableHeaderCell
        :col-span="2"
        name="title"
      >
        <span>Title</span>
      </TableHeaderCell>

      <TableHeaderCell
        :col-span="4"
        name="description"
      >
        <span>Description</span>
      </TableHeaderCell>

      <TableHeaderCell
        :col-span="1"
        centered
        name="domainAuthority"
      >
        <span>Breaking Change</span>
      </TableHeaderCell>

      <TableHeaderCell
        :col-span="1"
        centered
        name="approved_by"
      >
        <span>Approved By</span>
      </TableHeaderCell>

      <TableHeaderCell
        :col-span="1"
        centered
        name="created_at"
      >
        <span>Created At</span>
      </TableHeaderCell>

      <TableHeaderCell
        :col-span="1"
        centered
        name="approved_at"
      >
        <span>Approved At</span>
      </TableHeaderCell>

      <TableHeaderCell
        :col-span="1"
        centered
        name="buttons"
      />
    </TableHeaderRow>

    <TableBody
      v-if="data?.length > 0"
      ref="tableBody"
      class="tw-max-h-[70vh]"
    >
      <ApiChangeLogRow
        v-for="apiChangeLog in data"
        :key="apiChangeLog.id"
        :api-change-log="apiChangeLog"
      />
    </TableBody>

    <ZeroContent v-if="!data || !data.length">
      Looks like there are no <br>API Change Logs to display.
    </ZeroContent>
  </DataTable>

  <EditApiChangeLogModal />
  <DeleteApiChangeModal />
</template>
